import { useEffect, useMemo, useState } from 'react';
import { ZodType, z } from 'zod';

const makeValidOnlySchema = (s: z.ZodTypeAny) =>
	z.array(z.any()).transform((as) => as.filter((a) => s.safeParse(a).success));

const makeInValidOnlySchema = (s: z.ZodTypeAny) =>
	z.array(z.any()).transform((as) => as.filter((a) => !s.safeParse(a).success));

export function useValidate<T>(
	result: T[],
	schema: ZodType,
	onValidate: Function = () => {}
) {
	const [validItems, setValidItems] = useState<T[]>([]);
	const [invalidItems, setInvalidItems] = useState<T[]>([]);

	const validOnlyItemsSchema = useMemo(
		() => makeValidOnlySchema(schema),
		[schema]
	);

	const invalidOnlyItemsSchema = useMemo(
		() => makeInValidOnlySchema(schema),
		[schema]
	);

	useEffect(() => {
		if (!result || result.length < 1) return;

		const data = z.array(schema).safeParse(result);

		if (!data.success) {
			const valid = validOnlyItemsSchema.parse(result);
			const invalid = invalidOnlyItemsSchema.parse(result);

			setValidItems(valid);
			setInvalidItems(invalid);
			onValidate(data.error.issues);
			return;
		}

		setValidItems(data.data);
	}, [result]);

	return { valid: validItems, invalid: invalidItems };
}
